function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "open", "hideFab", "loading", "disabled", "onOpen", "onClose", "onMessage", "onReset", "fabIcon", "fabText", "openLabel", "closeLabel", "sendIcon", "closeIcon", "footer", "footerIcon", "title", "resetLabel", "placeholder", "validationMessage", "inputProps", "top", "right", "bottom", "left"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Ghost, Icon, Primary } from '@churchofjesuschrist/eden-buttons';
import { backgroundColorLevel3, backgroundColorLevel5, borderColorSecondary, borderRadius, grey2, setAppearanceConstantLocal, spacing16, spacing24, spacing4, spacing8, textColorPrimary, textColorSecondary, fontWeightNormal, fontSize16, lineHeight, sans, breakWidth480 } from '@churchofjesuschrist/eden-style-constants';
import { ChevronDown, Add, Clear, ArtificialIntelligence, Send, LoadingSpinner } from '@churchofjesuschrist/eden-icons';
import { Card } from '@churchofjesuschrist/eden-card';
import { Text5, Text6 } from '@churchofjesuschrist/eden-text';
import { H3 } from '@churchofjesuschrist/eden-headings';
import { TextArea } from '@churchofjesuschrist/eden-form-parts';
import ReceivedMessage from "./ReceivedMessage.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NOOP = function NOOP() {};
var Container = styled.div.withConfig({
  componentId: "sc-tw1x1f-0"
})(["position:fixed;display:flex;flex-direction:column;align-items:end;gap:", ";", " ", " ", " ", " font:normal normal ", " ", " / ", " ", ";& a{text-decoration:underline;&:hover{text-decoration:none;}}& ol{padding:revert;}:dir(rtl) svg,[dir='rtl'] svg{transform:scaleX(-1);}"], spacing16, function (_ref) {
  var $top = _ref.$top;
  return typeof $top === 'undefined' ? '' : "top: ".concat($top, ";");
}, function (_ref2) {
  var $right = _ref2.$right;
  return typeof $right === 'undefined' ? '' : "inset-inline-end: ".concat($right, ";");
}, function (_ref3) {
  var $bottom = _ref3.$bottom;
  return typeof $bottom === 'undefined' ? '' : "bottom: ".concat($bottom, ";");
}, function (_ref4) {
  var $left = _ref4.$left;
  return typeof $left === 'undefined' ? '' : "inset-inline-start: ".concat($left, ";");
}, fontWeightNormal, fontSize16, lineHeight, sans);
var Fab = styled(Primary).withConfig({
  componentId: "sc-tw1x1f-1"
})(["aspect-ratio:", ";border-radius:100vh;padding:", ";max-width:unset;"], function (_ref5) {
  var $hasText = _ref5.$hasText;
  return $hasText ? 'auto' : 1;
}, function (_ref6) {
  var $hasText = _ref6.$hasText;
  return $hasText ? "".concat(spacing16, " ").concat(spacing24) : spacing24;
});
var ChatDialog = styled(Card).withConfig({
  componentId: "sc-tw1x1f-2"
})(["--fab-height:", ";--top:", ";--right:", ";--bottom:", ";--left:", ";--padding-x:calc(var(--left) + var(--right));--padding-y:calc(var(--top) + var(--bottom) + var(--fab-height));position:relative;padding:0;background-color:", ";flex-direction:column;width:500px;max-width:calc(100svw - var(--padding-x));height:700px;max-height:calc(100svh - var(--padding-y));border-radius:", ";border:1px solid ", ";outline:none;overflow:hidden;color:", ";&[open]{display:flex;}"], function (_ref7) {
  var $hideFab = _ref7.$hideFab,
    $fabText = _ref7.$fabText;
  return $hideFab ? '0px' : "calc(".concat(spacing16, " + ").concat($fabText ? '56px' : '64px', ")");
}, function (_ref8) {
  var $top = _ref8.$top;
  return typeof $top === 'undefined' ? spacing16 : $top;
}, function (_ref9) {
  var $right = _ref9.$right;
  return typeof $right === 'undefined' ? spacing16 : $right;
}, function (_ref10) {
  var $bottom = _ref10.$bottom;
  return typeof $bottom === 'undefined' ? spacing16 : $bottom;
}, function (_ref11) {
  var $left = _ref11.$left;
  return typeof $left === 'undefined' ? spacing16 : $left;
}, backgroundColorLevel3, borderRadius, borderColorSecondary, textColorPrimary);

// Header
var _setAppearanceConstan = setAppearanceConstantLocal('chatbot-header-color', {
    light: grey2,
    dark: backgroundColorLevel5
  }),
  _setAppearanceConstan2 = _slicedToArray(_setAppearanceConstan, 2),
  headerColorDef = _setAppearanceConstan2[0],
  headerColor = _setAppearanceConstan2[1];
var HeaderContainer = styled.div.withConfig({
  componentId: "sc-tw1x1f-3"
})(["", ";width:100%;background-color:", ";border-bottom:1px solid ", ";display:flex;flex-wrap:nowrap;justify-content:space-between;align-items:start;"], headerColorDef, headerColor, borderColorSecondary);
var HeaderLabel = styled(H3).withConfig({
  componentId: "sc-tw1x1f-4"
})(["margin:", ";margin-inline-end:0;flex-shrink:1;"], spacing16);
var HeaderButtons = styled.span.withConfig({
  componentId: "sc-tw1x1f-5"
})(["display:flex;flex-wrap:wrap;align-items:start;flex-direction:row-reverse;margin:", ";column-gap:", ";@media (min-width:", "){flex-shrink:0;}"], spacing8, spacing4, breakWidth480);
var ResetButton = styled(Ghost).withConfig({
  componentId: "sc-tw1x1f-6"
})(["white-space:nowrap;"]);

// Footer
var ChatFooter = styled.div.withConfig({
  componentId: "sc-tw1x1f-7"
})(["", ";background-color:", ";padding:", ";color:", ";display:flex;align-items:center;gap:", ";"], headerColorDef, headerColor, spacing16, textColorSecondary, spacing8);

// ChatBar
var ChatbarContainer = styled.form.withConfig({
  componentId: "sc-tw1x1f-8"
})(["background-color:", ";border-top:1px solid ", ";border-bottom:", ";margin-top:auto;display:flex;align-items:end;"], backgroundColorLevel3, borderColorSecondary, function (_ref12) {
  var $bottomBorder = _ref12.$bottomBorder;
  return $bottomBorder ? "1px solid ".concat(borderColorSecondary) : 'none';
});
var MessageInputContainer = styled.div.withConfig({
  componentId: "sc-tw1x1f-9"
})(["display:flex;flex-direction:column;flex:1;"]);
var ValidationMessage = styled(Text6).withConfig({
  componentId: "sc-tw1x1f-10"
})(["color:", ";padding-bottom:", ";padding-inline-start:", ";"], textColorSecondary, spacing8, spacing8);
var MessageInput = styled(TextArea).withConfig({
  componentId: "sc-tw1x1f-11"
})(["min-height:100px;max-height:300px;height:0;margin:0;resize:none;outline:none;border:none;background-color:", ";scrollbar-gutter:stable;&[type]{appearance:none;box-sizing:border-box;}overscroll-behavior:contain;"], backgroundColorLevel3);
var SubmitButton = styled(Icon).withConfig({
  componentId: "sc-tw1x1f-12"
})(["margin:", ";"], spacing8);

// Messages
var _setAppearanceConstan3 = setAppearanceConstantLocal('color-scheme', {
    light: 'light',
    dark: 'dark'
  }),
  _setAppearanceConstan4 = _slicedToArray(_setAppearanceConstan3, 2),
  colorSchemeDef = _setAppearanceConstan4[0],
  colorScheme = _setAppearanceConstan4[1];
var MessageContainer = styled.div.withConfig({
  componentId: "sc-tw1x1f-13"
})(["", ";min-height:100px;flex:1;padding:", ";overflow-y:auto;display:flex;flex-direction:column;white-space:pre-wrap;scrollbar-gutter:stable;color-scheme:", ";overscroll-behavior:contain;"], colorSchemeDef, spacing8, colorScheme);
var LoadingMessage = styled(ReceivedMessage).withConfig({
  componentId: "sc-tw1x1f-14"
})(["display:flex;align-items:center;aspect-ratio:1;"]);

/**
 * @typedef {object} Props
 * @property {React.ReactNode} children Messages to render in the chat window.
 *
 * Should consist of `NoticeMessage`, `SentMessage`, `ReceivedMessage`, and `Feedback` components.
 * @property {boolean} [open] Whether to show the chat window.
 * @property {boolean} [loading] Whether to show a loading spinner.
 * @property {boolean} [hideFab] Whether to hide the floating action button that controls the chat window.
 * @property {boolean} [disabled] Whether to disable the send button.
 * @property {() => void} [onOpen] Event handler for when the chat window is opened.
 * @property {() => void} [onClose] Event handler for when the chat window is closed.
 * @property {(message: string) => void} [onMessage] Event handler for when a user submits a message.
 * @property {() => void} [onReset] Event handler for when the reset conversation button is clicked.
 * @property {React.ReactNode} [fabIcon] The content to display in the floating action button. Defaults to `<Chat />` when closed and `<ChevronDown />` when open.
 * @property {React.ReactNode} [fabText] Text to show next to the icon in the floating action button.
 * @property {string} [openLabel] A11y label for the floating action button. Defaults to `'Open'`.
 * @property {string} [closeLabel] A11y label for the floating action button. Defaults to `'Close'`.
 * @property {React.ReactNode} [sendIcon] The icon to display in the send message button.
 * @property {React.ReactNode} [closeIcon] The icon to display in the close button at the top of the chat window.
 * @property {React.ReactNode} [footerIcon] The icon to display in the left side of the footer.
 * @property {React.ReactNode} [footer] Content to display in the footer at the bottom of the chat window.
 *
 * Pass a falsy value to hide the entire footer.
 * @property {string} [title] The title to display at the top of the chat window.
 * @property {string} [resetLabel] The icon and text to display in the reset button.
 * @property {string} [placeholder] Placeholder text for the message input.
 * @property {string} [validationMessage] An optional string to display under the message input.
 * @property {Omit<React.ComponentProps<'textarea'>, 'placeholder'|'value'|'onChange'|'onKeyDown'|'ref'>} [inputProps] Extra props to pass to the message input.
 * @property {string} [top] The top position of the chat window.
 * @property {string} [right] The right position of the chat window. Defaults to `'1rem'`.
 * @property {string} [bottom] The bottom position of the chat window. Defaults to `'1rem'`.
 * @property {string} [left] The left position of the chat window.
 */

/**
 * @param {Props} props
 */
var AIChat = function AIChat(_ref13) {
  var children = _ref13.children,
    open = _ref13.open,
    _ref13$hideFab = _ref13.hideFab,
    hideFab = _ref13$hideFab === void 0 ? false : _ref13$hideFab,
    loading = _ref13.loading,
    disabled = _ref13.disabled,
    _ref13$onOpen = _ref13.onOpen,
    onOpen = _ref13$onOpen === void 0 ? NOOP : _ref13$onOpen,
    _ref13$onClose = _ref13.onClose,
    onClose = _ref13$onClose === void 0 ? NOOP : _ref13$onClose,
    _ref13$onMessage = _ref13.onMessage,
    onMessage = _ref13$onMessage === void 0 ? NOOP : _ref13$onMessage,
    onReset = _ref13.onReset,
    fabIcon = _ref13.fabIcon,
    fabText = _ref13.fabText,
    _ref13$openLabel = _ref13.openLabel,
    openLabel = _ref13$openLabel === void 0 ? 'Open' : _ref13$openLabel,
    _ref13$closeLabel = _ref13.closeLabel,
    closeLabel = _ref13$closeLabel === void 0 ? 'Close' : _ref13$closeLabel,
    sendIcon = _ref13.sendIcon,
    closeIcon = _ref13.closeIcon,
    _ref13$footer = _ref13.footer,
    footer = _ref13$footer === void 0 ? 'This tool is powered by AI. Responses may be incorrect.' : _ref13$footer,
    footerIcon = _ref13.footerIcon,
    _ref13$title = _ref13.title,
    title = _ref13$title === void 0 ? 'AI Assistant' : _ref13$title,
    _ref13$resetLabel = _ref13.resetLabel,
    resetLabel = _ref13$resetLabel === void 0 ? 'New Chat' : _ref13$resetLabel,
    placeholder = _ref13.placeholder,
    validationMessage = _ref13.validationMessage,
    _ref13$inputProps = _ref13.inputProps,
    inputProps = _ref13$inputProps === void 0 ? {} : _ref13$inputProps,
    top = _ref13.top,
    _ref13$right = _ref13.right,
    right = _ref13$right === void 0 ? spacing16 : _ref13$right,
    _ref13$bottom = _ref13.bottom,
    bottom = _ref13$bottom === void 0 ? spacing16 : _ref13$bottom,
    left = _ref13.left,
    rest = _objectWithoutProperties(_ref13, _excluded);
  var dialogRef = useRef();
  var messageInputRef = useRef();
  var messageContainerRef = useRef();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    message = _useState2[0],
    setMessage = _useState2[1];
  var buttonDisabled = disabled || loading && disabled !== false;
  useEffect(function () {
    if (messageContainerRef.current) {
      var observer = new MutationObserver(function (records) {
        var _messageContainerRef$;
        // Don't scroll to the bottom when the feedback component changes
        var isFeedbackChange = records.every(function (r) {
          return r.target.hasAttribute('data-feedback');
        });
        if (isFeedbackChange) return;

        // Scroll to the top of the most recent message
        var messages = (_messageContainerRef$ = messageContainerRef.current) === null || _messageContainerRef$ === void 0 ? void 0 : _messageContainerRef$.querySelectorAll('[data-scroll="true"]');
        if (messages.length) {
          var lastMessage = messages.item(messages.length - 1);
          lastMessage.scrollIntoView({
            block: 'start',
            inline: 'nearest',
            behavior: 'smooth'
          });
        }
      });
      observer.observe(messageContainerRef.current, {
        childList: true,
        subtree: true
      });
      return function () {
        observer.disconnect();
      };
    }
  }, []);
  useEffect(function () {
    // Handle open/close, and focus the message input on open.
    if (open) {
      var _dialogRef$current$sh, _dialogRef$current, _messageInputRef$curr, _messageInputRef$curr2, _messageContainerRef$2;
      dialogRef.current.returnValue = '';
      (_dialogRef$current$sh = (_dialogRef$current = dialogRef.current).show) === null || _dialogRef$current$sh === void 0 || _dialogRef$current$sh.call(_dialogRef$current);
      (_messageInputRef$curr = (_messageInputRef$curr2 = messageInputRef.current).focus) === null || _messageInputRef$curr === void 0 || _messageInputRef$curr.call(_messageInputRef$curr2);
      (_messageContainerRef$2 = messageContainerRef.current) === null || _messageContainerRef$2 === void 0 || _messageContainerRef$2.scrollTo({
        top: messageContainerRef.current.scrollHeight
      });
    } else {
      var _dialogRef$current$cl, _dialogRef$current2;
      (_dialogRef$current$cl = (_dialogRef$current2 = dialogRef.current).close) === null || _dialogRef$current$cl === void 0 || _dialogRef$current$cl.call(_dialogRef$current2, 'chatbot-closed');
    }
  }, [open]);
  useEffect(function () {
    if (messageInputRef.current) {
      // Automatically grow/shrink message input
      messageInputRef.current.style.height = '0';
      messageInputRef.current.style.height = messageInputRef.current.scrollHeight + 'px';
    }
  }, [message]);
  var handleClose = function handleClose(event) {
    if (dialogRef.current.returnValue !== 'chatbot-closed') {
      event.preventDefault();
      onClose(event);
    }
    setMessage('');
  };
  var handleMessage = function handleMessage(event) {
    event.preventDefault();
    if (!buttonDisabled) {
      onMessage(message);
      setMessage('');
    }
  };
  var handleMessageEnter = function handleMessageEnter(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      handleMessage(event);
    }
  };
  var handleEscape = function handleEscape(event) {
    if (event.key === 'Escape') {
      onClose(event);
      setMessage('');
    }
  };
  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({
    $top: top,
    $right: right,
    $bottom: bottom,
    $left: left
  }, rest), {}, {
    children: [/*#__PURE__*/_jsxs(ChatDialog, {
      "data-testid": "dialog",
      renderAs: "dialog",
      ref: dialogRef,
      onClose: handleClose,
      onKeyDown: handleEscape,
      $hideFab: hideFab,
      $fabText: fabText,
      $top: top,
      $right: right,
      $bottom: bottom,
      $left: left,
      children: [/*#__PURE__*/_jsxs(HeaderContainer, {
        children: [/*#__PURE__*/_jsx(HeaderLabel, {
          children: title
        }), /*#__PURE__*/_jsxs(HeaderButtons, {
          children: [/*#__PURE__*/_jsx(Icon, {
            "data-testid": "close",
            onClick: onClose,
            title: closeLabel,
            children: closeIcon || /*#__PURE__*/_jsx(Clear, {})
          }), onReset && /*#__PURE__*/_jsxs(ResetButton, {
            "data-testid": "reset",
            onClick: onReset,
            children: [/*#__PURE__*/_jsx(Add, {}), /*#__PURE__*/_jsx("span", {
              children: resetLabel
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs(MessageContainer, {
        ref: messageContainerRef,
        children: [children, loading && /*#__PURE__*/_jsx(LoadingMessage, {
          "data-testid": "loading",
          markdown: false,
          children: /*#__PURE__*/_jsx(LoadingSpinner, {
            size: spacing24
          })
        })]
      }), /*#__PURE__*/_jsxs(ChatbarContainer, {
        $bottomBorder: !!footer,
        onSubmit: handleMessage,
        children: [/*#__PURE__*/_jsxs(MessageInputContainer, {
          children: [/*#__PURE__*/_jsx(MessageInput, _objectSpread(_objectSpread({}, inputProps), {}, {
            ref: messageInputRef,
            placeholder: placeholder,
            value: message,
            onChange: function onChange(e) {
              return setMessage(e.target.value);
            },
            onKeyDown: handleMessageEnter,
            "data-testid": "message-input"
          })), validationMessage && /*#__PURE__*/_jsx(ValidationMessage, {
            children: validationMessage
          })]
        }), /*#__PURE__*/_jsx(SubmitButton, {
          type: "submit",
          disabled: buttonDisabled,
          "data-testid": "message-submit",
          children: sendIcon || /*#__PURE__*/_jsx(Send, {})
        })]
      }), !!footer && /*#__PURE__*/_jsxs(ChatFooter, {
        children: [footerIcon === undefined ? /*#__PURE__*/_jsx(ArtificialIntelligence, {
          size: spacing24
        }) : footerIcon, /*#__PURE__*/_jsx(Text5, {
          children: footer
        })]
      })]
    }), !hideFab && /*#__PURE__*/_jsxs(Fab, {
      onClick: open ? onClose : onOpen,
      "data-testid": "fab",
      title: open ? closeLabel : openLabel,
      $hasText: !!fabText,
      $open: open,
      children: [fabText && /*#__PURE__*/_jsx("span", {
        children: fabText
      }), fabIcon || (open ? /*#__PURE__*/_jsx(ChevronDown, {
        size: spacing24
      }) : /*#__PURE__*/_jsx(ArtificialIntelligence, {
        size: spacing24
      }))]
    })]
  }));
};
export default AIChat;